import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { TranslationsService } from '../services/translations.service';

export class SystemTranslateLoader implements TranslateLoader {
  constructor(private translationsService: TranslationsService) {}

  getTranslation(lang: string): Observable<any> {
    return this.translationsService.getSystemTranslations(lang);
  }
}

export const createSystemTranslateLoader = (translationsService: TranslationsService): TranslateLoader => new SystemTranslateLoader(translationsService);
